import { authActions } from "@common/redux/auth/actions";
import { IAuthReducerState } from "@common/redux/auth/interface";

export const initialState = {
  isAuthenticated: false,
  authData: null,
  activeUserRegistrationData: null,
  loaders: {
    login: false,
    logout: false,
    registerUser: false,
    refreshToken: false,
  },
  errors: {
    login: "",
    logout: "",
    registerUser: {
      errorCode: "",
      errorMessage: "",
    },
    refreshToken: "",
  },
};

export const authReducer = (
  state: IAuthReducerState = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case authActions.LOGIN:
      return {
        ...state,
        loaders: { ...state.loaders, login: true },
        errors: { ...state.errors, login: "" },
      };

    case authActions.LOGIN_SUCCESS: {
      const { sessionToken } = action?.payload?.authData;
      const updatedAuthData = {
        ...state?.authData,
        sessionToken,
      };

      return {
        ...state,
        isAuthenticated: !!sessionToken,
        authData: updatedAuthData,
        loaders: { ...state.loaders, login: false },
      };
    }

    case authActions.LOGIN_FAILURE:
      return {
        ...state,
        loaders: { ...state.loaders, login: false },
        errors: { ...state.errors, login: action.payload },
      };

    case authActions.LOGOUT:
      return {
        ...state,
        loaders: { ...state.loaders, logout: true },
        errors: { ...state.errors, logout: "" },
      };
    case authActions.LOGOUT_SUCCESS:
      return {
        ...state,
        isAuthenticated: false,
        authData: null,
        loaders: { ...state.loaders, logout: false },
      };

    case authActions.LOGOUT_FAILURE:
      return {
        ...state,
        loaders: { ...state.loaders, logout: false },
        errors: { ...state.errors, logout: action.payload },
      };

    case authActions.UPDATE_AUTH_TOKEN: {
      const { sessionToken } = action?.payload;

      const updatedAuthData = {
        ...state?.authData,
        sessionToken,
      };
      return {
        ...state,
        authData: updatedAuthData,
      };
    }

    case authActions.SET_ACTIVE_USER_REGISTER:
      return {
        ...state,
        activeUserRegistrationData: action.payload.activeUserRegistrationData,
      };

    case authActions.SEND_OTP:
      return {
        ...state,
      };

    case authActions.VERIFY_OTP:
      return {
        ...state,
      };

    case authActions.RESET_PASSWORD:
      return {
        ...state,
      };

    case authActions.REGISTER_USER_AFTER_OTP_VERIFICATION:
      return {
        ...state,
        loaders: { ...state.loaders, registerUser: true },
        errors: { ...state.errors, registerUser: "" },
      };

    case authActions.REGISTER_USER_AFTER_OTP_VERIFICATION_SUCCESS:
      const { tokenExpiryTime, sessionToken, tokenRefreshTime } =
        action?.payload;
      const updatedAuthData = {
        ...state?.authData,
        tokenExpiryTime,
        sessionToken,
        tokenRefreshTime,
      };
      return {
        ...state,
        isAuthenticated: true,
        authData: updatedAuthData,
        loaders: { ...state.loaders, registerUser: false },
      };

    case authActions.REGISTER_USER_AFTER_OTP_VERIFICATION_FAILURE:
      return {
        ...state,
        loaders: { ...state.loaders, registerUser: false },
        errors: { ...state.errors, registerUser: action.payload },
      };

    case authActions.RESET_USER_REGISTER_ERROR:
      return {
        ...state,
        errors: { ...state.errors, registerUser: {} },
      };

    default:
      return { ...state };
  }
};
